import { createSlice } from "@reduxjs/toolkit";

export const vendorType = createSlice({
  name: "vendorType",
  initialState: {
    vendorType: "securityAgency",
    vendorTypeName: "Security Agency",
    // dropdownLabel: "Security Agency",
  },

  reducers: {
    updateSelectedValue: (state = vendorType?.initialState, action) => {
      state.vendorType = action.payload;
    },
    updateSelectedLabel: (state = vendorType?.initialState, action) => {
      state.vendorTypeName = action.payload;
    },
  },
});
export const { updateSelectedValue, updateSelectedLabel } = vendorType.actions;
export default vendorType.reducer;
